// Also gates the help center chat bubble — see
// yola-editor/src/js/modules/help-center/middleware/init-help-center.js.
export const AI_CHAT_FEATURE_FLAG = 'ai_chat';

// A subset of the chat's `DisplayMode` (see constants/messages.js): the editor
// has no layout for `left` or `fullscreen` yet, so it ignores requests for them.
export const DISPLAY_MODES = {
  FLOATING: 'floating',
  RIGHT: 'right',
};

export default {
  IFRAME_TITLE: 'Yola AI',
  // Keep in sync with $ai-chat-panel-width in src/scss/ai-chat.scss.
  PANEL_WIDTH: 400,
  DISPLAY_MODES,
};
